module.exports = __webpack_public_path__ + "static/media/person.5bd591a3.png";